import { render, staticRenderFns } from "./SplitPaymentScreen.vue?vue&type=template&id=4af517de&scoped=true"
import script from "./SplitPaymentScreen.vue?vue&type=script&lang=js"
export * from "./SplitPaymentScreen.vue?vue&type=script&lang=js"
import style0 from "./SplitPaymentScreen.vue?vue&type=style&index=0&id=4af517de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af517de",
  null
  
)

export default component.exports